import { apiConfig } from '../../config/apiConfig';
import { fetchData } from './fetchData';

export async function fetchCredits() {
  var data = await fetchData(apiConfig.getCredits, {
    method: 'GET',
  });

  return { json: data.json, error: data.error, ok: data.ok };
}
